import NamedDto from 'modules/base/dto/NamedDto';
import SimulationMonitorFieldEditDto from './SimulationMonitorFieldEditDto';

export class SimulationMonitorEditDto extends NamedDto {
	constructor() {
		super();

		/** @type {number} */
		this.aspect = null;

		/** @type {number} */
		this.simulationMonitorLog = null;

		/** @type {number} */
		this.readInterval = null;

		/** @type {number} */
		this.timeWindow = null;

		/** @type {number} */
		this.maxIterations = null;

		/** @type {SimulationMonitorFieldEditDto[]} */
		this.fields = null;
	}

	/**
	 * @typedef {Object} _SimulationMonitorEditDtoProps
	 * @property {number} aspect
	 * @property {number} simulationMonitorLog
	 * @property {number} readInterval
	 * @property {number} timeWindow
	 * @property {number} maxIterations
	 * @property {SimulationMonitorFieldEditDto[]} fields
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _SimulationMonitorEditDtoProps} SimulationMonitorEditDtoProps
	 */
	/**
	 *
	 * @param {SimulationMonitorEditDtoProps} props
	 * @returns {SimulationMonitorEditDto}
	 */
	setup(props) {
		super.setup(props);

		this.aspect = props.aspect;
		this.simulationMonitorLog = props.simulationMonitorLog;
		this.readInterval = props.readInterval;
		this.timeWindow = props.timeWindow;
		this.maxIterations = props.maxIterations;
		this.fields = props.fields !== null ? props.fields.map(d => new SimulationMonitorFieldEditDto().setup(d)) : [];

		return this;
	}
}

export default SimulationMonitorEditDto;
